import { isLinked, LinkableField } from '@synqo/frontend-component-library';
import { getPriceOriginLabel } from './getPriceOriginLabel';
import { EnumPriceOrigin } from './Generated';

interface IPriceFinderTarget {
    price_list: LinkableField;
    price_origin: EnumPriceOrigin;
}

export function getPriceLabel(target: IPriceFinderTarget) {
    if (isLinked(target.price_list)) {
        return target.price_list.display_string;
    } else {
        return getPriceOriginLabel(target.price_origin);
    }
}
